// signup

export const SELLERSIGNUPREQUEST="SELLERSIGNUPREQUEST"
export const SELLERSIGNUPSUCESS="SELLERSIGNUPSUCESS"
export const SELLERSIGNUPFAIL="SELLERSIGNUPFAIL"
export const SELLERBACKFROMSIGNUPFAIL="SELLERBACKFROMSIGNUPFAIL"

// login

export const SELLERLOGINEQUEST="SELLERLOGINREQUEST"
export const SELLERLOGINSUCESS="SELLERLOGINSUCESS"
export const SELLERLOGINFAIL="SELLERLOGINFAIL"
export const SELLERBACKFROMLOGINFAIL="SELLERBACKFROMLOGINFAIL"

//logout

export const SELLERLOGOUTSUCESSFUL = 'SELLERLOGOUTSUCESSFUL'